import { documentReady } from "@sazka/utils/document-ready";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import { useKeenSliderConfig } from "../composables/use-keen-slider-config";
import { useTicketsSlider } from "../composables/use-tickets-slider";

documentReady(() => {
    const container = document.getElementById("promo-news-slider");
    const buttonLeft = document.getElementById("promo-news-slider-prev");
    const buttonRight = document.getElementById("promo-news-slider-next");
    if (!container) {
        return;
    }

    onViewportEnter(container, 0).then(() => {
        const sliderConfig = useKeenSliderConfig();

        useTicketsSlider({ container, buttonLeft, buttonRight, sliderConfig, updateOnLogout: true });
    });
});
